import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../AppProvider";
import { faLoader } from "../../../utilities/fontawesomeIcons";
import moment from "moment";
import { transformStringToColor } from "../../../utilities/utilities";
import { useShipmentsStatisticsAggregationDailyContext } from "../providers/ShipmentsStatisticsAggregationDaily";
import { useInView } from "react-intersection-observer";
import { useMemo } from "react";

const ShipmentsPerDay = () => {
  const { dictionary } = useAppContext();
  const { data, loader, filters } =
    useShipmentsStatisticsAggregationDailyContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  const barContent = useMemo(() => {
    if (!inView || !data?.length) return null;

    const dataToDisplay = {
      labels: data?.map((s) => moment(s.date).format("DD/MM/YYYY") || 0) || [],
      datasets: [
        {
          data: data?.map((s) => s.amount || 0) || [],
          backgroundColor: ["#54f066"],
          maxBarThickness: 40,
        },
      ],
    };

    return (
      <Bar
        className="mt-2"
        data={dataToDisplay}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              ticks: {
                autoSkip: false,
                maxRotation: 90,
                minRotation: 45,
              },
            },
            y: {
              beginAtZero: true,
              min: 0,
              ticks: {
                stepSize: 1,
              },
              title: {
                display: true,
                text: dictionary.shipments.total_shipments,
              },
            },
          },
        }}
      />
    );
  }, [inView, data]);

  return (
    <div ref={ref} className="box-container text-center h-100">
      <div className="row mb-1" style={{ height: "60px" }}>
        <div className="col">
          <label className="label-4 lh-1 mb-1">
            {dictionary.kpi.shipments_in_period}
          </label>
          <label className="label-2">
            {moment(filters.start).isSame(moment(filters.end), "day")
              ? moment(filters.start).format("DD/MM/YYYY")
              : moment(filters.start).format("DD/MM/YYYY") +
                " - " +
                moment(filters.end).format("DD/MM/YYYY")}
          </label>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label className="label-5">
            {dictionary.kpi.shipments_in_period_desc}
          </label>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col">
          {loader ? (
            <FontAwesomeIcon icon={faLoader} spin size="4x" />
          ) : data ? (
            <div
              style={{ width: "100%", height: "450px", position: "relative" }}
            >
              {barContent}
            </div>
          ) : (
            <label className="label-3">
              {dictionary.messages.no_results_found}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShipmentsPerDay;
